<script setup>
import {
  computed,
  toRefs,
} from 'vue';
import baseImage from '@/assets/img/carousel_no-image.png';

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
  className: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: '',
  },
  styleString: {
    type: String,
    default: '',
  },
  imageWidth: {
    type: String,
    default: '',
  },
  imageHeight: {
    type: String,
    default: '',
  },
});

const {
  type,
  src,
} = toRefs(props);

const imageTypeToBaseImage = computed(() => {
  switch (type.value) {
    case 'value':
      return baseImage;
    default:
      return baseImage;
  }
});

const url = computed(() => {
  if (!src.value) {
    return imageTypeToBaseImage.value;
  }

  return src.value;
});

</script>
<template>
  <img
    :src="url"
    :class="className"
    :style="styleString"
    :alt="alt"
  />
</template>
